/* eslint-disable max-statements */
import { FilterMatchMode } from 'primereact/api';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Column } from 'primereact/column';
import { DataTable, DataTableFilterMeta } from 'primereact/datatable';
import { toast } from 'react-toastify';
import { InputText } from 'primereact/inputtext';

import React, { useEffect, useState } from 'react';
import {
    useCreateStartDateOverrideMutation,
    useDeleteStartDateOverridesMutation,
    useGetStartDateOverridesQuery,
} from '../../../features/edsDashboard/edsExceptionStartDate/edsExceptionStartDateSlice';


import { IDeleteException, IStartDateOverride } from '../../../utils/types';

import '../../../pages/edsDashboard/edsDashboard.scss';

export const EdsExceptionTabStartDate = (props: any) => {
    const [CreateStartDateOverride] = useCreateStartDateOverrideMutation();

    const [isAlertVisible, setIsAlertVisible] = React.useState(false);
    const [isNoDataAlertVisible, setIsNoDataAlertVisible] = React.useState(false);
    const [exceptionDate, setExceptionDate] = useState(new Date());
    const today = new Date();
    const month = today.getMonth();
    const year = today.getFullYear();
    const maxDate = new Date(year, month + 1, 0);
    const minDate = new Date(year, month - 8, 1);
    const [startDateOverrides, setStartDateOverrides] = useState<any>();
    const [selectedProducts, setSelectedProducts] = useState<any>(null);
    const [DeleteStartDateOverridesException] = useDeleteStartDateOverridesMutation();

    // const nextMonth = month === 11 ? 0 : month + 1;


    const handleNoDataClick = () => {
        setIsNoDataAlertVisible(true);
        setTimeout(() => {
            setIsNoDataAlertVisible(false);
        }, 3999);
    };
    const handleButtonClick = () => {
        setIsAlertVisible(true);
        setTimeout(() => {
            setIsAlertVisible(false);
        }, 3999);
    };

    const ExceptionDateOnChange = (e: any) => {
        setExceptionDate(e.value);
    };
    const createStartDateOverride = (startdate: any) => {
        CreateStartDateOverride(startdate)
            .unwrap()
            .then((response: any) => {
                if (!response.data) {
                    handleButtonClick();
                }
            })
            .then((error: any) => {
                if (error) console.log(error);
            });
    };


    const submitStartDateOverride = () => {
        if (
            props.agentNumber === undefined ||
            props.agentNumber == null ||
            props.agentNumber === ''
        ) {
            toast.error('Select a Valid Associate from Associate Lookup. ');
            return;
        }

        const startdate: IStartDateOverride = {
            employeenumber: Number(props.agentNumber),
            createby: props.loggedEmpNum,
            scorecardid: props.inputScorecardId,
            projectstartoverridedate: exceptionDate,
            status: true,
        };

        if (isValidStartDateOverride(startdate)) {
            createStartDateOverride(startdate);
        } else {
            handleNoDataClick();
            toast.error('Invalid scorecardAssign data. Please check the data before sending. ');

        }
    };
    const isValidStartDateOverride = (data: IStartDateOverride): boolean => {
        // Perform data validation here based on your specific constraints
        if (
            typeof data.employeenumber !== 'number' ||
            typeof data.createby !== 'string' ||
            typeof data.scorecardid !== 'number' ||
            !(data.projectstartoverridedate instanceof Date) ||
            typeof data.status !== 'boolean'
        ) {
            return false;
        }

        // Additional validation logic based on your specific requirements
        // For example, you can check for specific ranges, string length, etc.

        return true;
    };
    const { data: startDateOverridesData } = useGetStartDateOverridesQuery(
        {
            employeenumber: props.agentNumber,
            // scorecardVersionId: null,
        },
        { skip: !props.agentNumber }
    );

    useEffect(() => {
        setStartDateOverrides(startDateOverridesData?.data);
    }, [startDateOverridesData]);

    const DeleteStartDateOverrides = (startdate: any) => {
        DeleteStartDateOverridesException(startdate)
            .unwrap()
            .then((response: any) => {
                console.log("response", response);
                toast.success('Deleted Successfully');
            })
            .then((error: any) => {
                if (error) {
                    console.log(error);
                    toast.error('Error');
                }
            });
    };
    const deleteStartDateException = () => {
        const sCardIds: any[] = [];
        let oID = '';
        selectedProducts.forEach((e: any) => {
            oID = e.oracleID;
            sCardIds.push(e.scorecard_id);
        });

        const startdate: IDeleteException = {
            oracleIDs: oID,
            scorecardId: sCardIds,
        };
        if (startdate.oracleIDs === undefined || startdate.oracleIDs == null) {
            handleNoDataClick();
        } else {
            DeleteStartDateOverrides(startdate);
        }
    };

    const [globalFilterValue, setGlobalFilterValue] = useState('');

    const [filters, setFilters] = useState<DataTableFilterMeta>({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });


    const onGlobalFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;

        const filtersSet = { ...filters };
        // @ts-ignore
        filtersSet.global.value = value;

        setFilters(filtersSet);
        setGlobalFilterValue(value);
    };
    const renderHeader = () => {
        return (
            <div className="d-inline-block justify-content-between w-100">
                <span className="p-input-icon-left mt-4 mt-md-0 d-inline-block">
                    <i className="pi pi-search" />
                    <InputText
                        value={globalFilterValue}
                        onChange={onGlobalFilterChange}
                        placeholder="Keyword Search "
                    />
                </span>
                <div className="d-inline-block float-start float-md-end">
                    <Button
                        type="button"
                        icon="pi pi-delete"
                        label="Delete"
                        disabled={!selectedProducts}
                        onClick={deleteStartDateException}
                        className="btn-primary"
                    />
                </div>
            </div>
        );
    };

    const header = renderHeader();

    return (
        < div>
            <div className="row">
                {isAlertVisible && (
                    <p className="error-text">
                        An associate can only have one override on a
                        scorecard.
                    </p>
                )}
                {isNoDataAlertVisible && (
                    <p className="error-text">
                        Select An associate before you apply
                    </p>
                )}
                <div className="col-md-3">
                    <h6 className="mt-3 pt-2">New Start Date</h6>
                    <Calendar
                        id="basic"
                        value={exceptionDate}
                        onChange={ExceptionDateOnChange}
                        showIcon
                        className="custom-calendar mb-4"
                        minDate={minDate}
                        maxDate={maxDate}
                        dateFormat="dd-M-yy"
                    />
                    <Button
                        className="btn-primary float-end"
                        onClick={submitStartDateOverride}
                    >
                        Apply
                    </Button>
                    <Button className="btn-secondary me-3float-end">
                        Cancel
                    </Button>
                </div>
            </div>
            <div />

            <div className="row">
                {startDateOverrides !== null ? (
                    <div>
                        <div>
                            <DataTable
                                value={startDateOverrides}
                                emptyMessage="No records found."
                                header={header}
                                selection={selectedProducts}
                                onSelectionChange={(e) =>
                                    setSelectedProducts(e.value)
                                }
                                globalFilterFields={[
                                    'name',
                                    'oracleID',
                                    'scorecard_name',
                                    'startdate',
                                ]}
                                filterDisplay="menu"
                                filters={filters}
                                className="startDateOverrideTable"
                                dataKey="scorecard_id"
                                selectionMode="multiple"
                            >
                                <Column selectionMode="multiple" />
                                <Column
                                    header="Name"
                                    field="name"
                                    sortable
                                    filterField="name"
                                />
                                <Column
                                    header="OracleId"
                                    field="oracleID"
                                    filterField="oracleID"
                                    sortable
                                />
                                <Column
                                    header="Scorecard"
                                    field="scorecard_name"
                                    filterField="scorecard_name"
                                    sortable
                                />
                                <Column
                                    header="Start Date"
                                    field="startdate"
                                    filterField="startdate"
                                    sortable
                                />
                            </DataTable>
                        </div>
                    </div>
                ) : (
                    <div className="card mt-3 ms-1 me-1 shadow bg-body rounded border-0">
                        <div className="card-body p-0 pe-5 ps-4 align-middle text-center">
                            <div
                                className="row"
                                style={{ height: '15vh' }}
                            >
                                <div
                                    className="col-md-12"
                                    style={{
                                        margin: 'auto',
                                        paddingTop: '10px',
                                    }}
                                >
                                    <p className="align-middle">
                                        No results found, Try selecting an
                                        associate
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>

        </div>

    );
};
